const $time = $('.lg-pop').data('timer');
const $button = $('.lg-pop__button');
const $buttonOpen = $('.lg-pop__button--open');
const $buttonClose = $('.lg-pop__button--close')
const $modal = $('.lg-pop__modal');

const scroll = () => {
	if ( window.pageYOffset > 200 ) {
		$button.addClass('lg-pop__button--visible');
	}
};

const openForm = () => {
	var popup = new Foundation.Dropdown($('.lg-pop__modal'));
	popup.open();

	$button.addClass('lg-pop__button--visible');
	$buttonClose.removeClass('hidden');
	$modal.addClass('slideInRight');
	$modal.removeClass('slideOutRight');
	$modal.removeClass('lg-pop__modal--hidden');
}


const openModal = () => {
	var popup = new Foundation.Dropdown($('.lg-pop__modal'));
	popup.open()

	$buttonClose.removeClass('hidden');
	$modal.addClass('slideInRight');
	$modal.removeClass('slideOutRight');
	$modal.removeClass('lg-pop__modal--hidden');
}

const closeModal = () => {
	var popup = new Foundation.Dropdown($('.lg-pop__modal'));
	popup.close()
	$modal.removeClass('slideInRight');
	$modal.addClass('slideOutRight');
	$buttonClose.addClass('hidden');
}

const eventScroll = () => {
	let waiting = false, endScrollHandle;
	$( window ).scroll( function () {
		if ( waiting ) {
			return;
		}
		waiting = true;
		clearTimeout( endScrollHandle );
		scroll();
		setTimeout( function () {
			waiting = false;
		}, 100 );
		endScrollHandle = setTimeout( function () {
			scroll();
		}, 200 );
	} );
};

const events = () => {
	eventScroll();
	$buttonOpen.on('click', openModal);
	$buttonClose.on('click', closeModal);

	if ($time) {
        $(window).on('load', function() {
            setTimeout(() => {
                openForm()
            }, $time * 1000);
        });
    }
};

const init = () => {
	events();
};

export default init;